// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__3FSSx","error":"Checkbox_error__3qU6F","checkbox":"Checkbox_checkbox__2GAiw"};